import { useCookieConsent } from "../global/cookieConsent";

export const Localization = () => {
    const { consent, openSettings } = useCookieConsent();

    if(consent !== 'accepted') {
        return (
            <div className="mt-8 rounded-lg border bg-gray-50 p-6 text-center">
                <p className="text-sm text-gray-600">La carte Google Maps est bloquée tant que les contenus externes ne sont pas autorisés.</p>
                <button type="button" onClick={openSettings} className="mt-3 rounded-md border border-primary px-4 py-2 text-sm font-medium text-primary">
                    Gérer mes cookies
                </button>
            </div>
        );
    }

    return (
        <div
            className="mt-8 overflow-hidden rounded-lg border"
        >
            <iframe
                src="https://www.google.com/maps/embed?pb=!1m18!1m12!1m3!1d995.1601326291153!2d11.547636352475878!3d3.886989880974477!2m3!1f0!2f0!3f0!3m2!1i1024!2i768!4f13.1!3m3!1m2!1s0x108bc5bff09c0027%3A0xba9dfe40d2e19522!2sField%20Legality%20Advisory%20Group%20(FLAG)!5e0!3m2!1sen!2scm!4v1691585972401!5m2!1sen!2scm"
                width="600"
                height="400"
                className="w-full"
                style={{border: 0}}
                allowFullScreen
                loading="lazy"
                referrerPolicy="no-referrer-when-downgrade"
                title="Localisation de FLAG"
            />
        </div>
    );
}

export default Localization;
